module.exports = __webpack_public_path__ + "media/images/icons/eye-black-icon-a5bf12bb36b85b776818bfee70206797.svg";